import styled from 'styled-components'
import { Text } from '@agro-club/agroclub-shared'

export const HeaderCellSubtitle = styled(Text).attrs({
  typography: 'accentMedium',
  color: 'secondary',
})``
